<script setup lang="ts">
import type { Property } from '~/core/entities/property';
import { FeaturesGridSkeleton } from '.';
import { cn } from '@/utils';
import type { Condo } from '~/core/entities/condo/Condo';

const props = withDefaults(
	defineProps<{
		featuresByCategory:
			| Property['featuresByCategory']
			| Condo['featuresByCategory'];
		isLoading?: boolean;
		title?: string;
		gridClass?: string;
	}>(),
	{
		title: 'Características'
	}
);

const hasFeatures = computed(
	() => Object.keys(props.featuresByCategory ?? {}).length > 0
);
</script>

<template>
	<div class="flex w-full flex-col">
		<FeaturesGridSkeleton v-if="isLoading" />

		<ExpandableContainer v-else-if="hasFeatures">
			<div class="flex w-full flex-col gap-6">
				<h2
					class="p-0 font-matter-sq text-[28px] font-normal leading-[42px] text-primary"
				>
					{{ title }}
				</h2>
				<div class="flex flex-col gap-4">
					<div
						v-for="[category, features] in Object.entries(
							featuresByCategory ?? {}
						)"
						:key="category"
						class="flex w-full flex-col gap-2"
					>
						<h3
							class="font-matter-sq text-[18px] font-normal leading-[27px] text-primary"
						>
							{{ category }}
						</h3>
						<div
							:class="
								cn('grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-4', gridClass)
							"
						>
							<div
								v-for="feature in features"
								:key="`feature:${feature.name}`"
								class="flex items-center gap-2 font-sans text-sm font-normal leading-[150%] text-primary-light-1"
							>
								<IconMaterialSymbolsLightCheck class="size-5" />
								<span
									class="font-sans text-sm font-normal leading-[21px] text-primary"
								>
									{{ feature.name }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ExpandableContainer>
	</div>
</template>
